<template>
  <div class="relative">
    <Header :title="'亲友管理'" />

    <!-- 搜索框区域 -->
    <div class="search-section">
      <nut-searchbar
        v-model="phone"
        place-text="输入亲友手机号码"
        :has-search-button="false"
        :animation="true"
        search-icon-color="#999"
        search-icon-size="12px"
        @blur="checkPhone"
        @submit="bindRelativeByPhone"
      />
      <div class="search-button" @click="bindRelativeByPhone">绑定
      </div>
    </div>

    <!-- 联系列表 -->
    <div class="relative-section">
      <div v-if="relativeList.length===0" class="relative-none">暂无亲友关联</div>
      <div v-for="(item,index) of relativeList" :key="index" class="relative-item">
        <div class="relative-up">
          <span>电话：{{ item.relationPhone }}</span>
          <span class="gray">申请时间：{{ item.createdDate.split(' ')[0] }}</span>
        </div>
        <div class="relative-down">
          <div class="relative-title">
            <span>姓名</span>
            <span>状态</span>
            <span />
          </div>
          <div class="relative-value">
            <span class="relative-name">{{ item.relationName }}</span>
            <span v-if="item.auditState==='Related'" class="relative-status">已关联</span>
            <span v-else class="relative-status gray">未关联</span>
            <span v-if="item.auditState==='Wait'" class="relative-button-wrp">
              <span class="relative-button-small" @click="reject(item)">拒绝</span>
              <span class="relative-button-small" @click="pass(item)">通过</span>
            </span>
            <span v-if="item.auditState==='Related'" class="relative-button" @click="unbind(item)">解除关联</span>
            <span v-if="item.auditState==='Unrelated'" class="relative-button" @click="del(item)">删除</span>
          </div>
        </div>
      </div>
    </div>
    <div class="foot" />
    <Footer :active="4" />
  </div>
</template>

<script>
import Header from '@/components/Header/Index'
import Footer from '@/components/Footer/Index'
import { Dialog, Toast } from 'vant'
import {
  getHallRelativeData,
  unbindHallRelative,
  auditHallRelative,
  deleteHallRelative,
  bindHallRelative
} from '@/api/Personal/Hall'

export default {
  name: 'Relative',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      hallId: 0,
      relativeList: [],
      phone: '',
      pageIndex: 1
    }
  },
  mounted() {
    this.hallId = this.$route.params.id
    this.getHallRelativeList()
  },
  methods: {
    getHallRelativeList() {
      getHallRelativeData(this.hallId, this.pageIndex).then(res => {
        if (res.success) {
          this.pageIndex++
          res.data.rows.forEach(item => {
            this.relativeList.push(item)
          })
          if (res.data.total - this.relativeList.length > 0) {
            this.getHallRelativeList()
          }
        }
      })
    },
    checkPhone() {
      if (!this.$isPhone(this.phone)) {
        Toast.fail('请输入正确的手机号码')
        return false
      } else return true
    },
    bindRelativeByPhone() {
      if (this.checkPhone()) {
        bindHallRelative(this.phone, this.hallId).then(res => {
          if (res.success) {
            Toast.success('添加亲友成功')
            this.relativeList = []
            this.pageIndex = 1
            this.getHallRelativeList()
          } else {
            if (res.code === 50000) {
              Toast.fail(res.msg)
            }
          }
        })
      }
    },
    pass(item) {
      Dialog.confirm({
        title: '提示',
        width: '250px',
        message: `您确定将绑定 ${item.relationName} 亲人帐号`,
        confirmButtonColor: '#eea105',
        closeOnPopstate: true
      })
        .then(() => {
          // on confirm
          auditHallRelative(item.id, true).then(res => {
            if (res.success) {
              Toast.success('关联成功')
              this.relativeList = []
              this.pageIndex = 1
              this.getHallRelativeList()
            } else {
              Toast.fail('请求出错')
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    reject(item) {
      Dialog.confirm({
        title: '提示',
        width: '250px',
        message: `您确定将拒绝绑定 ${item.relationName} 亲人帐号`,
        confirmButtonColor: '#eea105',
        closeOnPopstate: true
      })
        .then(() => {
          // on confirm
          auditHallRelative(item.id, false).then(res => {
            if (res.success) {
              Toast.success('拒绝成功')
              this.relativeList = []
              this.pageIndex = 1
              this.getHallRelativeList()
            } else {
              Toast.fail('请求出错')
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    unbind(item) {
      Dialog.confirm({
        title: '提示',
        width: '250px',
        message: `您确定将解绑 ${item.relationName} 亲人帐号`,
        confirmButtonColor: '#eea105',
        closeOnPopstate: true
      })
        .then(() => {
          // on confirm
          unbindHallRelative(this.hallId, item.id).then(res => {
            if (res.success) {
              Toast.success('解绑成功')
              this.relativeList = []
              this.pageIndex = 1
              this.getHallRelativeList()
            } else {
              Toast.fail('请求出错')
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    del(item) {
      Dialog.confirm({
        title: '提示',
        width: '250px',
        message: `您确定将删除 ${item.relationName} 关联帐号`,
        confirmButtonColor: '#eea105',
        closeOnPopstate: true
      })
        .then(() => {
          // on confirm
          deleteHallRelative(item.id).then(res => {
            if (res.success) {
              Toast.success('删除成功')
              this.relativeList = []
              this.pageIndex = 1
              this.getHallRelativeList()
            } else {
              Toast.fail('请求出错')
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';

.relative {
  padding-top: 15px;
}

.search-section {
  height: 35px;
  display: flex;
  margin: 0 15px 15px 15px;
  justify-content: space-between;

  .nut-searchbar {
    flex: 1;
    margin: auto 0;
    width: 286px;
    height: 35px;

    ::v-deep input {
      height: 35px;
      line-height: 35px;
      font-size: 14px;
    }

    ::v-deep .search-input {
      border: 1px solid #ddd;
      border-radius: 5px;
    }
  }

  .search-button {
    margin: auto 0;
    border-radius: 5px;
    width: 75px;
    height: 35px;
    line-height: 35px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    background: $primary-color-bright;
  }
}

.relative-section {
  margin: 0 15px;

  .relative-none {
    width: 100px;
    margin: 25px auto;
    font-size: 14px;
    color: $title-color-light;
  }

  .relative-item {
    margin-bottom: 25px;
    background: #fff;
    border-radius: 5px;
    box-shadow: 1px 1px 3px #f0f0f0,
    -1px -1px 3px #f0f0f0;

    .relative-up {
      margin: 0 15px;
      height: 40px;
      line-height: 40px;
      position: relative;
      font-size: 12px;
      display: flex;
      justify-content: space-between;
    }

    .relative-up::after {
      content: "";
      position: absolute;
      left: 0;
      top: auto;
      bottom: 0;
      right: auto;
      height: 1px;
      width: 100%;
      background-color: #f0f0f0;
    }

    .relative-down {
      margin: 0 15px;

      .relative-title {
        display: flex;
        justify-content: space-between;
        height: 46px;
        line-height: 46px;
        font-size: 16px;

        span {
          width: 80px;
          text-align: center;
        }
      }

      .relative-value {
        display: flex;
        justify-content: space-between;
        height: 46px;
        line-height: 46px;
        font-size: 14px;

        > span {
          width: 95px;
          height: 30px;
          line-height: 30px;
          text-align: center;
        }

        .relative-name {
          @extend %ellipsis;
        }

        .relative-status {
          width: 50px;
          color: $primary-color-bright;
        }

        .gray {
          color: grey;
        }

        .relative-button-wrp {
          display: flex;
          justify-content: space-between;

          .relative-button-small {
            color: #fff;
            background: $primary-color-bright;
            width: 45px;
            border-radius: 15px;
          }
        }

        .relative-button {
          width: 95px;
          color: #fff;
          background: $primary-color-bright;
          border-radius: 15px;
        }
      }
    }
  }
}

.foot {
  height: 50px;
}
</style>
